import * as React from "react";

import AddToButton from "../DocumentSetDocumentRelation/AddTo/Button";

import { documentDisplayTitle } from "../../src/document_display_title";

interface DocumentSummaryProps {
  document: DocumentSnakeModel
  canAddFromSummary?: boolean
  currentUser?: UserSnakeModel
  currentRoleDefinition?: RoleDefinitionSnakeModel
  categoryId?: number
}

export default function DocumentSummary(props: DocumentSummaryProps) {
  const {
    document,
    canAddFromSummary,
    currentUser,
    currentRoleDefinition,
    categoryId,
  } = props;

  const mediaIcons = [];

  if(document.description.indexOf("extra_video") !== -1) {
    mediaIcons.push(<i key="extra_video" className="fa fa-video" style={{"paddingRight": "5px"}} />);
  }

  if(document.description.indexOf("extra_image") !== -1) {
    mediaIcons.push(<i key="extra_image" className="fa fa-image" style={{"paddingRight": "5px"}} />);
  }

  if(document.description.indexOf("extra_audio") !== -1) {
    mediaIcons.push(<i key="extra_audio" className="fa fa-volume-high" style={{"paddingRight": "5px"}} />);
  }

  const canAddButton = canAddFromSummary &&
    (currentUser?.is_admin ||
      (currentRoleDefinition && ["Faculty", "Manager", "ReelDx_Faculty"].includes(currentRoleDefinition?.name)));

  const addToButton = canAddButton && (
    <AddToButton
      document={document}
      currentUser={currentUser}
      currentRoleDefinition={currentRoleDefinition}
      categoryId={categoryId}
    />
  );

  return (
    <div className="cover-wrapper">
      {addToButton}

      <a className="cover summary" href={`/documents/${document.id}`}>
        <img src={document.cover_image} alt={`Case ${document.id} Cover Image`}  width="2092" height="1170"/>
        <h4 className="name">{documentDisplayTitle(document)}</h4>
        {mediaIcons.length > 0 && <h4>{mediaIcons}</h4>}
      </a>
    </div>
  );
}
